import React, { useState, useEffect, useCallback, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import ChatNavSidebar from "../../../components/dashboardcomponents/ChatV2/ChatNavSidebar";
import ChatList from "../../../components/dashboardcomponents/ChatV2/ChatList";
import ChatHeaderV2 from "../../../components/dashboardcomponents/ChatV2/ChatHeaderV2";
import ChatDetails from "../../../components/dashboardcomponents/ChatV2/ChatDetails";
import ChatMessageComponent from "../../../components/dashboardcomponents/ChatComponents/ChatMessageComponent";
import ChatTicketPopup from "../../../components/dashboardcomponents/ChatComponents/ChatTicketPopup";
import ChatTranscriptPopUp from "../../../components/dashboardcomponents/ChatComponents/ChatTranscriptPopUp";
import AssignChat from "../../../components/dashboardcomponents/ChatComponents/AssignChatPopUp";
import CannedPopup from "../../../components/dashboardcomponents/ChatComponents/CannedPopup";
import { ReactComponent as NoChat } from "../../../assets/images/ChatImages/nochat.svg";
import { archivedRoomApi } from "../../../store/features/archivedRoom";
import { getCustomerRequest } from "../../../store/features/getCustomerRequest";
import { getMessageById } from "../../../store/features/getRoomById";
import { getChatRoomById } from "../../../store/features/getChatRoomById";
import {
  resolveCustomerIdFromGetMessagePayload,
  resolveLiveChatBanCustomerId,
  resolvePeopleCustomerIdsFromGetCustomerUser,
  resolveVisitorIdFromRoomUsers,
} from "../../../utils/messagePayloadCustomer";
import { publishRoomPreview } from "../../../utils/pendingRoomPreview";
import { isJoinNoticeMessage } from "../../../utils/messageNotification";
import { markNotificationsReadForContext } from "../../../store/features/notifications";
import {
  clearOpenRoomCache,
  getOpenRoomCache,
  setOpenRoomCache,
} from "../../../utils/openChatRoomCache";
import { clearArchiveChatListWarmCache } from "../../../utils/archiveChatListWarmCache";
import { clearUnassignedChatListWarmCache } from "../../../utils/unassignedChatListWarmCache";
import { clearActiveChatListWarmCache } from "../../../utils/activeChatListWarmCache";
import {
  resolvePayloadRoom,
  resolveRoomSourceGroup,
} from "../../../utils/chatRoomPayload";
import { CHAT_NAV_SIDEBAR_WIDTH } from "../../../constants/chatV2Constants";
import {
  chatPathForFilter,
  filterIdFromTab,
  filterIdFromView,
  filterIdToView,
  mergeChatCounts,
  parseVisitorProfileFromMessages,
} from "../../../utils/chatV2Helpers";
import { openUserDetailSidebar } from "../../../store/features/userDetailSidebarSlice";
import useDebounce from "../../../hooks/useDebounce";
import CustomerBanModal from "../../../components/dashboardcomponents/People/Customers/CustomerBanModal";
import { banCustomer as banCustomerApi } from "../../../store/features/customersApi";
import { buildCustomerBanPayload } from "../../../utils/customerMappers";
import { useSocket } from "../../../SocketContext";
import "../../../components/dashboardcomponents/ChatV2/chatV2Overrides.css";
import "../../../components/dashboardcomponents/ChatV2/chatV2MessageOverrides.css";

function ChatV2() {
  const [searchParams] = useSearchParams();
  const [latestMsgTime, setLatestMsgTime] = useState(null);
  const [selectUser, setSelectUser] = useState(null);
  const [getRoomId, setGetRoomId] = useState([]);
  const [ticketPopup, setTicketPopup] = useState(false);
  const [transcriptPopup, setTranscriptPopup] = useState(false);
  const [AssignChatPopup, setAssignChatPopup] = useState(false);
  const [chatSideBar, setChatSideBar] = useState(true);
  const [cannedMsg, setCannedMsg] = useState("");
  const [cannedResponse, setCannedResponse] = useState(false);
  const [refreshChatList, setRefreshChatList] = useState(false);
  const [pendingRemoveRoomId, setPendingRemoveRoomId] = useState(null);
  const [pendingAssignedRoomId, setPendingAssignedRoomId] = useState(null);
  const [pendingAssignedClaimForSelf, setPendingAssignedClaimForSelf] =
    useState(true);
  const [typingIndicator, setTypingIndicator] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [customerReady, setCustomerReady] = useState(false);
  const [sourceGroup, setSourceGroup] = useState(null);
  const [sourceLoading, setSourceLoading] = useState(false);
  const [openRoom, setOpenRoom] = useState(false);
  const [loading, setLoading] = useState(true);
  const [assignedAgentImage, setAssignedAgentImage] = useState(null);
  const [chatNavOpen, setChatNavOpen] = useState(true);
  const [detailsOpen, setDetailsOpen] = useState(true);
  const [activeFilterId, setActiveFilterId] = useState(() =>
    filterIdFromTab(searchParams.get("tab"))
  );
  const [chatSearch, setChatSearch] = useState("");
  const debouncedChatSearch = useDebounce(chatSearch, 350);
  const [banCustomer, setBanCustomer] = useState(null);
  const [chatCounts, setChatCounts] = useState({
    all: 0,
    assigned_to_me: 0,
    unassigned: 0,
    closed: 0,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const socket = useSocket();
  const userData = useSelector((state) => state.loginToken);

  useEffect(() => {
    setActiveFilterId(filterIdFromTab(searchParams.get("tab")));
  }, [searchParams]);

  const handleOpenRoom = () => {
    setOpenRoom((prev) => !prev);
    if (selectUser) {
      setSelectUser((prev) => ({
        ...prev,
        is_unAssigned: false,
        unAssignedCount: 0,
        num: 0,
      }));
    }
  };

  const handleRefreshChatList = () => {
    const id = selectUserRef.current?.id;
    if (id) clearOpenRoomCache(id);
    clearArchiveChatListWarmCache();
    clearUnassignedChatListWarmCache();
    clearActiveChatListWarmCache();
    setRefreshChatList((prev) => !prev);
  };

  useEffect(() => {
    const roomId = selectUser?.id;
    if (roomId) {
      dispatch(markNotificationsReadForContext({ roomId }));
    }
  }, [dispatch, selectUser?.id]);

  const customerIdRef = useRef(null);
  const prevRoomIdRef = useRef(null);
  const selectUserRef = useRef(selectUser);
  useEffect(() => {
    selectUserRef.current = selectUser;
  }, [selectUser]);

  const fetchCustomerData = (cId) => {
    if (!cId) return;
    setCustomerReady(false);
    dispatch(getCustomerRequest({ id: cId }))
      .then(async (data) => {
        if (customerIdRef.current !== cId) return;
        if (data?.payload?.status === 200) {
          const item = data?.payload?.user;
          // Ban/history use People customer ids; get-customer may nest those under `crm`.
          const peopleIds = resolvePeopleCustomerIdsFromGetCustomerUser(item);
          const row = [
            {
              id: peopleIds.id || item?._id,
              userId: peopleIds.userId || item?._id,
              crmId: peopleIds.crmId,
              name: item?.name,
              email: item?.email,
              time: item?.updatedAt,
              location: item?.location?.city,
              lat: item?.location?.latitude,
              lng: item?.location?.longitude,
              is_guest: item?.is_guest,
              last_seen: item?.last_seen,
              visited_pages: item?.visited_pages,
              visit_count: item?.visit_count,
              chat_count: item?.chat_count,
              ticket_count: item?.ticket_count,
              ip_address: item?.ip_address,
              os: item?.os,
              browser: item?.browser,
              people_status:
                item?.people_status || item?.crm?.people_status || null,
              banned_until:
                item?.banned_until || item?.crm?.banned_until || null,
            },
          ];
          setCustomerData(row);
          const su = selectUserRef.current;
          if (su?.id) {
            setOpenRoomCache(su.id, !!su.is_archived, { customerData: row });
            // Keep selectUser.customerId on the visitor — never leave it as the agent.
            if (peopleIds.id || peopleIds.userId) {
              setSelectUser((prev) => {
                if (!prev || prev.id !== su.id) return prev;
                const nextId = peopleIds.userId || peopleIds.id;
                if (prev.customerId && String(prev.customerId) === String(nextId)) {
                  return prev;
                }
                return { ...prev, customerId: nextId || prev.customerId };
              });
            }
          }
        } else if (data?.payload?.status === 401) {
          navigate("/login");
        }
      })
      .catch(() => {})
      .finally(() => {
        if (customerIdRef.current === cId) setCustomerReady(true);
      });
  };

  useEffect(() => {
    if (!selectUser?.id) {
      setGetRoomId([]);
      setCustomerData([]);
      setCustomerReady(false);
      setSourceGroup(null);
      return;
    }

    // Closed tab owns message load via ArchiveUser. During search that list is
    // unmounted, so this effect must load archived rooms too or the skeleton sticks.
    const isSearching = Boolean(String(debouncedChatSearch || "").trim());
    const archiveListOwnsMessageLoad =
      !!selectUser?.is_archived &&
      activeFilterId === "closed" &&
      !isSearching;
    if (archiveListOwnsMessageLoad) {
      return;
    }

    const openedRoomId = selectUser.id;
    const isArchivedRoom = !!selectUser?.is_archived;
    let cancelled = false;
    const cached = getOpenRoomCache(openedRoomId, isArchivedRoom);
    const hasCachedMessages = cached != null && Array.isArray(cached.messages);
    if (hasCachedMessages) {
      setGetRoomId(cached.messages);
      setAssignedAgentImage(cached.assignedAgentImage ?? null);
      if (cached.sourceGroup != null) {
        setSourceGroup(cached.sourceGroup);
      } else if (cached.selectUserMerge?.sourceGroup) {
        setSourceGroup(cached.selectUserMerge.sourceGroup);
      }
      setSelectUser((prev) => {
        if (!prev || prev.id !== openedRoomId) return prev;
        return { ...prev, ...(cached.selectUserMerge || {}) };
      });
      if (cached.customerData?.length) {
        setCustomerData(cached.customerData);
        const cid =
          selectUser?.customerId ||
          selectUser?.roomUsers?.[0] ||
          cached.selectUserMerge?.customerId ||
          cached.selectUserMerge?.roomUsers?.[0] ||
          cached.customerData[0]?.id;
        if (cid) customerIdRef.current = cid;
      }
      setLoading(false);
    } else {
      setSourceGroup(null);
      setLoading(true);
    }

    // Messages that arrive while a different chat is open never reach this room's
    // cache, so always revalidate. The cached paint above keeps it flicker-free.
    dispatch(getMessageById({ id: openedRoomId }))
      .then(async (data) => {
        if (cancelled) return;
        if (typeof data.payload === "undefined") {
          if (!hasCachedMessages) {
            toast.error("Some Error Occured. Please try again later.");
            setGetRoomId([]);
          }
          setLoading(false);
        } else if (data?.payload?.status === 200) {
          const messages = Array.isArray(data?.payload?.messages)
            ? data.payload.messages
            : [];
          setGetRoomId(messages);
          setAssignedAgentImage(data.payload?.assignedAgent?.agent_image);

          // A freshly started chat can be listed without its opening message
          // (the widget welcome), so the thread is the only source for the
          // sidebar preview until the next message arrives.
          const lastMessage =
            [...messages].reverse().find((m) => !isJoinNoticeMessage(m)) || null;
          if (lastMessage) {
            publishRoomPreview(openedRoomId, {
              description: lastMessage.content,
              attachment: Boolean(lastMessage.file_image),
              iso: lastMessage.createdAt,
            });
          }

          const payloadRoom = resolvePayloadRoom(data.payload);
          // get-message often has no populated group; never wipe Source with null —
          // GET /chat-room/room/:id owns sourceGroup.
          const roomSourceGroup = resolveRoomSourceGroup(payloadRoom);
          if (roomSourceGroup) {
            setSourceGroup(roomSourceGroup);
          }
          const payloadUsers = Array.isArray(payloadRoom?.users)
            ? payloadRoom.users
            : [];
          const loggedInAgentId = userData?.response?.user?._id;
          const lastVisitorMessage =
            [...messages].reverse().find((msg) => !msg?.isAgent) || null;
          const resolvedCustomerId = resolveCustomerIdFromGetMessagePayload(
            data.payload,
            {
              prevCustomerId: selectUser?.customerId,
              loggedInAgentId,
              payloadUsers,
              visitorMessage: lastVisitorMessage,
            }
          );

          const roomUsers = payloadUsers.map((user) => user?._id).filter(Boolean);
          const mergedCustomerId =
            selectUser?.customerId || resolvedCustomerId || null;
          const mergedRoomUsers =
            selectUser?.roomUsers?.length > 0
              ? selectUser.roomUsers
              : roomUsers.length
                ? roomUsers
                : resolvedCustomerId
                  ? [resolvedCustomerId]
                  : [];

          setSelectUser((prev) => {
            if (!prev || prev.id !== openedRoomId) return prev;
            const hasCustomerId = !!prev.customerId;
            const hasRoomUsers = prev?.roomUsers?.length > 0;
            const nextSourceGroup = roomSourceGroup || prev.sourceGroup || null;
            if (hasCustomerId && hasRoomUsers) {
              return { ...prev, sourceGroup: nextSourceGroup };
            }
            return {
              ...prev,
              customerId: hasCustomerId
                ? prev.customerId
                : resolvedCustomerId || null,
              roomUsers: hasRoomUsers
                ? prev.roomUsers
                : roomUsers.length
                  ? roomUsers
                  : resolvedCustomerId
                    ? [resolvedCustomerId]
                    : [],
              sourceGroup: nextSourceGroup,
            };
          });

          const cachePayload = {
            messages,
            assignedAgentImage: data.payload?.assignedAgent?.agent_image ?? null,
            selectUserMerge: {
              customerId: mergedCustomerId,
              roomUsers: mergedRoomUsers,
              sourceGroup:
                roomSourceGroup ||
                cached?.sourceGroup ||
                cached?.selectUserMerge?.sourceGroup ||
                null,
            },
          };
          if (roomSourceGroup) {
            cachePayload.sourceGroup = roomSourceGroup;
          } else if (cached?.sourceGroup) {
            cachePayload.sourceGroup = cached.sourceGroup;
          }

          if (!resolvedCustomerId && !selectUser?.customerId) {
            const parsedProfile = parseVisitorProfileFromMessages(messages);
            if (parsedProfile) {
              const guestRow = [
                {
                  id: null,
                  name: parsedProfile.name || "",
                  email: parsedProfile.email || "",
                  time: lastVisitorMessage?.createdAt || "",
                  location: "",
                  lat: null,
                  lng: null,
                  is_guest: true,
                  last_seen: "",
                  visit_count: 0,
                  chat_count: 0,
                  ticket_count: 0,
                  ip_address: "",
                  os: "",
                  browser: "",
                  visited_pages: [],
                },
              ];
              setCustomerData(guestRow);
              cachePayload.customerData = guestRow;
              setCustomerReady(true);
            }
          }
          setOpenRoomCache(openedRoomId, isArchivedRoom, cachePayload);
          setLoading(false);
        } else {
          if (!hasCachedMessages) setGetRoomId([]);
          setLoading(false);
        }
      })
      .catch(async (error) => {
        if (cancelled) return;
        if (!hasCachedMessages) {
          toast.error(error);
          setGetRoomId([]);
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [
    selectUser?.id,
    selectUser?.is_archived,
    activeFilterId,
    debouncedChatSearch,
    dispatch,
    userData?.response?.user?._id,
  ]);

  // Source group comes from GET /chat-room/room/:id (roomData.group_id), not get-message.
  useEffect(() => {
    const roomId = selectUser?.id;
    if (!roomId) {
      setSourceGroup(null);
      setSourceLoading(false);
      return undefined;
    }

    const isArchived = !!selectUser?.is_archived;
    const cached = getOpenRoomCache(roomId, isArchived);
    const cachedGroup =
      cached?.sourceGroup ||
      cached?.selectUserMerge?.sourceGroup ||
      selectUser?.sourceGroup ||
      null;
    if (cachedGroup) {
      setSourceGroup(cachedGroup);
      setSourceLoading(false);
    } else {
      setSourceGroup(null);
      setSourceLoading(true);
    }

    let cancelled = false;
    dispatch(getChatRoomById({ id: roomId }))
      .then((data) => {
        if (cancelled) return;
        if (data?.payload?.status !== 200) {
          setSourceLoading(false);
          return;
        }
        const payloadRoom = resolvePayloadRoom(data.payload);
        const roomSourceGroup = resolveRoomSourceGroup(payloadRoom);
        setSourceGroup(roomSourceGroup);
        setSourceLoading(false);
        setOpenRoomCache(roomId, isArchived, {
          sourceGroup: roomSourceGroup,
          selectUserMerge: {
            ...(cached?.selectUserMerge || {}),
            sourceGroup: roomSourceGroup,
          },
        });
        setSelectUser((prev) => {
          if (!prev || String(prev.id) !== String(roomId)) return prev;
          if (
            (prev.sourceGroup?.id || null) === (roomSourceGroup?.id || null) &&
            (prev.sourceGroup?.name || null) === (roomSourceGroup?.name || null)
          ) {
            return prev;
          }
          return { ...prev, sourceGroup: roomSourceGroup };
        });
      })
      .catch(() => {
        if (!cancelled) setSourceLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [selectUser?.id, selectUser?.is_archived, dispatch]);

  useEffect(() => {
    const roomId = selectUser?.id || null;
    const isArchived = !!selectUser?.is_archived;
    const agentId = userData?.response?.user?._id;
    const cId =
      resolveVisitorIdFromRoomUsers(
        [
          selectUser?.customerId,
          ...(Array.isArray(selectUser?.roomUsers) ? selectUser.roomUsers : []),
        ],
        agentId
      ) || null;
    const roomChanged = roomId !== prevRoomIdRef.current;
    const cached = roomId ? getOpenRoomCache(roomId, isArchived) : null;

    if (roomChanged) {
      prevRoomIdRef.current = roomId;
      customerIdRef.current = null;
      if (cached?.customerData?.length) {
        setCustomerData(cached.customerData);
        setCustomerReady(true);
        const skipId =
          cId ||
          resolveVisitorIdFromRoomUsers(
            [
              cached.selectUserMerge?.customerId,
              ...(Array.isArray(cached.selectUserMerge?.roomUsers)
                ? cached.selectUserMerge.roomUsers
                : []),
              cached.customerData[0]?.userId,
              cached.customerData[0]?.id,
            ],
            agentId
          );
        if (skipId) customerIdRef.current = skipId;
      } else {
        setCustomerData([]);
        setCustomerReady(false);
      }
    }

    if (!cId) {
      if (cached?.customerData?.length) return;
      if (!loading && selectUser?.title !== "Loading...") {
        setCustomerReady(true);
      }
      return;
    }

    if (customerIdRef.current === cId) return;
    customerIdRef.current = cId;

    if (!roomChanged) setCustomerData([]);
    fetchCustomerData(cId);
  }, [
    selectUser?.id,
    selectUser?.customerId,
    selectUser?.roomUsers,
    selectUser?.is_archived,
    selectUser?.title,
    loading,
    userData?.response?.user?._id,
  ]);

  useEffect(() => {
    if (!selectUser?.id || loading) return;
    const archived = !!selectUser.is_archived;
    if (!getOpenRoomCache(selectUser.id, archived)) return;
    setOpenRoomCache(selectUser.id, archived, { messages: getRoomId });
  }, [getRoomId, selectUser?.id, selectUser?.is_archived, loading]);

  useEffect(() => {
    if (!selectUser?.id || loading) return;
    const archived = !!selectUser.is_archived;
    if (!getOpenRoomCache(selectUser.id, archived)) return;
    if (!customerData?.length) return;
    setOpenRoomCache(selectUser.id, archived, { customerData });
  }, [customerData, selectUser?.id, selectUser?.is_archived, loading]);

  // Keep details panel in sync with selection (V2 always shows details column when open)
  useEffect(() => {
    if (selectUser && detailsOpen) {
      setChatSideBar(true);
      dispatch(openUserDetailSidebar());
    }
  }, [selectUser?.id, detailsOpen, dispatch]);

  const handleArchivedRoom = useCallback(() => {
    const user = selectUserRef.current;
    if (!user?.id || user.is_archived) return;
    const roomId = user.id;

    // Same socket sequence as End chat so ban→end stays consistent.
    socket?.emit("archive-chat", roomId);
    socket?.emit("mark-read", roomId);
    socket?.emit("visitor_tab_closed", {
      business_id: user.businessId,
      userId: user.customerId || null,
    });

    // Leave the open thread before the archive socket can paint the
    // "closed by an agent" fallback on this conversation.
    clearOpenRoomCache(roomId);
    setSelectUser(null);
    setGetRoomId([]);
    setChatSideBar(false);
    setDetailsOpen(false);
    setPendingRemoveRoomId(roomId);

    // Stay on the current filter — do not jump to Closed. Drop roomId from the
    // URL so the ended chat closes; counts are updated via removeRoomId below.
    const tab = (searchParams.get("tab") || "").toLowerCase();
    if (tab === "unassigned") {
      navigate("/chat?tab=unassigned");
    } else if (tab === "archive" || tab === "closed") {
      navigate("/chat?tab=closed");
    } else {
      navigate("/chat");
    }

    dispatch(archivedRoomApi({ id: roomId }))
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.");
        } else if (
          data?.payload?.status === 200 ||
          data?.payload?.success === true
        ) {
          // Counts are owned by ChatBar: `pendingRemoveRoomId` reaches it as
          // `removeRoomId` and `markRoomClosed` adjusts every tab, then reports
          // back through onCountsChange. Adjusting them here too subtracted the
          // same room twice and showed one less than the list.
        } else if (
          data?.payload?.status === 500 ||
          data?.payload?.status === 401
        ) {
          toast.error("Some Error Occured. Please try again later.");
        }
      })
      .catch(async (error) => {
        toast.error(error);
      });
  }, [dispatch, navigate, searchParams, socket]);

  const handleFilterSelect = (filterId) => {
    // Re-clicking the active All/Unassigned/Closed filter was clearing the
    // open chat (then auto-open would fight it). Keep the current selection.
    if (filterId === activeFilterId) return;
    setActiveFilterId(filterId);
    setSelectUser(null);
    setChatSideBar(false);
    navigate(chatPathForFilter(filterId));
  };

  const handleChatBarViewChange = (view) => {
    setActiveFilterId(filterIdFromView(view));
  };

  const handleCountsChange = useCallback((counts) => {
    setChatCounts((prev) => mergeChatCounts(prev, counts));
  }, []);

  const handleBanVisitor = () => {
    const customerId = resolveLiveChatBanCustomerId({
      selectUser,
      customerData,
      loggedInAgentId: userData?.response?.user?._id,
    });
    if (!customerId) {
      toast.error("Unable to ban visitor: customer not found.");
      return;
    }
    setBanCustomer({
      id: customerId,
      name: customerData?.[0]?.name || selectUser?.title || "Visitor",
    });
  };

  const handleBanConfirm = async (duration) => {
    if (!banCustomer?.id) return;
    const body = buildCustomerBanPayload(duration);
    const result = await dispatch(
      banCustomerApi({ customerId: banCustomer.id, body })
    );
    if (banCustomerApi.fulfilled.match(result)) {
      toast.success(
        result.payload?.message || `${banCustomer.name} has been banned`
      );
      setBanCustomer(null);
      // Ban should also close an open live chat (skip if already ended).
      const openChat = selectUserRef.current;
      if (openChat?.id && !openChat.is_archived) {
        handleArchivedRoom();
      }
    } else {
      toast.error(result.payload?.message || "Failed to ban customer");
    }
  };

  const controlledView = filterIdToView(activeFilterId);

  return (
    <Box className="chatv2-page">
      <Box
        sx={{
          width: chatNavOpen ? CHAT_NAV_SIDEBAR_WIDTH : 0,
          flexShrink: 0,
          minHeight: 0,
          overflow: "hidden",
          transition: "width 0.2s ease",
          borderRight: chatNavOpen ? "1px solid #E5E9EC" : "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: CHAT_NAV_SIDEBAR_WIDTH,
            height: "100%",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ChatNavSidebar
            chatCounts={chatCounts}
            activeFilterId={activeFilterId}
            onFilterSelect={handleFilterSelect}
            searchQuery={chatSearch}
            onSearchChange={setChatSearch}
          />
        </Box>
      </Box>

      <ChatList
        headerTitle={selectUser?.title || ""}
        onToggleNav={() => setChatNavOpen((v) => !v)}
        chatBarProps={{
          setLatestMsgTime,
          selectUser,
          setSelectUser,
          setGetRoomId,
          getRoomId,
          setAssignedAgentImage,
          refreshChatList,
          openRoom,
          typingIndicator,
          setTypingIndicator,
          setChatSideBar: (open) => {
            setChatSideBar(open);
            if (open) setDetailsOpen(true);
          },
          isRoomOpen: chatSideBar,
          setRoomMessagesLoading: setLoading,
          controlledView,
          onViewChange: handleChatBarViewChange,
          onCountsChange: handleCountsChange,
          basePath: "/chat",
          removeRoomId: pendingRemoveRoomId,
          onRemoveRoomConsumed: () => setPendingRemoveRoomId(null),
          assignedRoomId: pendingAssignedRoomId,
          assignedRoomClaimForSelf: pendingAssignedClaimForSelf,
          onAssignedRoomConsumed: () => {
            setPendingAssignedRoomId(null);
            setPendingAssignedClaimForSelf(true);
          },
          searchQuery: debouncedChatSearch,
        }}
      />

      <Box
        className="chatv2-thread"
        sx={{
          flex: "1 1 592px",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          bgcolor: "#fff",
          overflow: "hidden",
        }}
      >
        {selectUser ? (
          <>
            <ChatHeaderV2
              customerData={customerData}
              messages={getRoomId}
              archivedRoom={handleArchivedRoom}
              setAssignChatPopup={setAssignChatPopup}
              latestMsgTime={latestMsgTime}
              selectUser={selectUser}
              setTicketPopup={setTicketPopup}
              setTranscriptPopup={setTranscriptPopup}
              onBanVisitor={handleBanVisitor}
              detailsOpen={detailsOpen}
              onToggleDetails={() => setDetailsOpen((v) => !v)}
            />
            <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
              <ChatMessageComponent
                typingIndicator={typingIndicator}
                setTypingIndicator={setTypingIndicator}
                unArchivedRoom={handleRefreshChatList}
                selectUser={selectUser}
                setSelectUser={setSelectUser}
                setChatSideBar={(open) => {
                  setChatSideBar(open);
                  if (open) setDetailsOpen(true);
                }}
                setCannedMsg={setCannedMsg}
                setCannedResponse={setCannedResponse}
                getRoomId={getRoomId}
                assignedAgentImage={assignedAgentImage}
                loading={loading}
                setGetRoomId={setGetRoomId}
                triggerOpenRoom={handleOpenRoom}
                onRoomAssigned={(roomId) => {
                  setPendingAssignedClaimForSelf(true);
                  setPendingAssignedRoomId(roomId);
                }}
                variant="v2"
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              px: 4,
              textAlign: "center",
            }}
          >
            <NoChat />
            <Typography sx={{ mt: 2, fontSize: 16, fontWeight: 600, color: "#061522" }}>
              No chats
            </Typography>
            <Typography sx={{ mt: 1, fontSize: 14, color: "#8B97A2", maxWidth: 360 }}>
              Why not see who&apos;s on your website right now and start a chat
              proactively?
            </Typography>
          </Box>
        )}

        {ticketPopup && (
          <ChatTicketPopup setTicketPopup={setTicketPopup} selectUser={selectUser} />
        )}
        {transcriptPopup && (
          <ChatTranscriptPopUp
            setTranscriptPopup={setTranscriptPopup}
            selectUser={selectUser}
          />
        )}
        {AssignChatPopup && (
          <AssignChat
            selectUser={selectUser}
            setSelectUser={setSelectUser}
            setAssignChatPopup={setAssignChatPopup}
            assignChat={handleRefreshChatList}
            setChatSideBar={setChatSideBar}
            onRoomAssigned={(roomId, { claimForSelf = false } = {}) => {
              setPendingAssignedClaimForSelf(claimForSelf);
              setPendingAssignedRoomId(roomId);
            }}
          />
        )}
        {cannedResponse && (
          <CannedPopup cannedMsg={cannedMsg} setCannedResponse={setCannedResponse} />
        )}
      </Box>

      {selectUser && (
        <Box
          sx={{
            width: detailsOpen ? 280 : 0,
            flexShrink: 0,
            minHeight: 0,
            overflow: "hidden",
            transition: "width 0.2s ease",
            borderLeft: detailsOpen ? "1px solid #E5E9EC" : "none",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: 280,
              height: "100%",
              minHeight: 0,
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ChatDetails
              customerData={customerData}
              getRoomId={getRoomId}
              customerLoading={!customerReady}
              customerId={resolveLiveChatBanCustomerId({
                selectUser,
                customerData,
                loggedInAgentId: userData?.response?.user?._id,
              })}
              sourceGroup={sourceGroup || selectUser?.sourceGroup || null}
              sourceLoading={sourceLoading}
              onToggleDetails={() => setDetailsOpen((v) => !v)}
            />
          </Box>
        </Box>
      )}

      <CustomerBanModal
        open={Boolean(banCustomer)}
        customer={banCustomer}
        onClose={() => setBanCustomer(null)}
        onConfirm={handleBanConfirm}
      />
    </Box>
  );
}

export default ChatV2;
